<template>
  <div class="accordion" :id="`accordion-${appId}`">
    <div class="accordion-item bg-white border border-gray-200">
      <h2 class="accordion-header mb-0" :id="`heading-${appId}`">
        <button
          class="
            accordion-button
            relative
            flex
            items-center
            w-full
            py-4
            px-5
            text-base text-gray-800 text-left
            bg-white
            border-0
            rounded-none
            transition
            focus:outline-none
          "
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="`#collapse-${appId}`"
          aria-expanded="false"
          :aria-controls="`collapse-${appId}`"
        >{{ title }}</button>
      </h2>
      <div
        :id="`collapse-${appId}`"
        class="accordion-collapse collapse"
        :aria-labelledby="`heading-${appId}`"
        :data-bs-parent="`#accordion-${appId}`"
      >
        <div class="accordion-body py-4 px-5">
          <slot />
          <div class="mt-6 flex justify-end">
            <slot name="actions" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MathAccordion",
  props: {
    title: String,
  },
  data() {
    return {
      appId: Math.random().toString(36).substring(8),
    };
  },
};
</script>
